import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { joinAsStationLeader, getRebusSession } from '../services/rebusSessionService';
import { getRebus } from '../services/rebusService';
import { RebusSessionProvider, useRebusSession } from '../context/RebusSessionContext';
import StationJoinScreen from '../components/rebus/station/StationJoinScreen';
import StationLeaderView from '../components/rebus/station/StationLeaderView';

function StationContent({ sessionId, stationId, rebus }) {
  const { session, loading, error } = useRebusSession();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <span className="material-symbols-outlined text-4xl text-teal-600 animate-spin">progress_activity</span>
          <p className="text-gray-500 mt-3 font-medium">Lastar stasjon...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl p-6 shadow-lg text-center max-w-sm">
          <span className="material-symbols-outlined text-4xl text-red-500 mb-2">error</span>
          <p className="text-gray-700 font-semibold mb-1">Noko gjekk gale</p>
          <p className="text-gray-500 text-sm">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <StationLeaderView
      session={session}
      rebus={rebus}
      stationId={stationId}
    />
  );
}

export default function RebusStationPage() {
  const { sessionId: urlSessionId } = useParams();
  const [joined, setJoined] = useState(false);
  const [sessionId, setSessionId] = useState(urlSessionId || '');
  const [stationId, setStationId] = useState('');
  const [leaderName, setLeaderName] = useState('');
  const [rebus, setRebus] = useState(null);
  const [joinError, setJoinError] = useState(null);
  const [joining, setJoining] = useState(false);

  // If URL has sessionId, don't auto-join, just pre-fill
  // User still needs to pick a station and enter name

  const handleJoin = async (sid, stId, name) => {
    setJoining(true);
    setJoinError(null);

    try {
      await joinAsStationLeader(sid, stId, name);

      // Fetch rebus data for the station view
      const session = await getRebusSession(sid);
      const rebusData = await getRebus(session.rebusId);

      setSessionId(sid);
      setStationId(stId);
      setLeaderName(name);
      setRebus(rebusData);
      setJoined(true);
    } catch (err) {
      setJoinError(err.message);
      setJoining(false);
    }
  };

  if (!joined) {
    return (
      <>
        <StationJoinScreen onJoin={handleJoin} />
        {joinError && (
          <div className="fixed bottom-4 left-4 right-4 bg-red-500 text-white px-4 py-3 rounded-xl shadow-lg font-medium text-sm text-center z-50">
            {joinError}
          </div>
        )}
      </>
    );
  }

  return (
    <RebusSessionProvider sessionId={sessionId}>
      <StationContent
        sessionId={sessionId}
        stationId={stationId}
        rebus={rebus}
      />
    </RebusSessionProvider>
  );
}
